import { render } from "./LecLogo.vue?vue&type=template&id=3ff2e103&scoped=true&ts=true"
import script from "./LecLogo.vue?vue&type=script&lang=ts"
export * from "./LecLogo.vue?vue&type=script&lang=ts"

import "./LecLogo.vue?vue&type=style&index=0&id=3ff2e103&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff2e103"]])

export default __exports__